import { Box, BoxProps } from '@mui/material';
import React from 'react';

interface Props extends BoxProps {
  ratioWidth: number;
  ratioHeight: number;
  children: React.ReactNode;
}

export const AspectRatio: React.FC<Props> = ({ children, ratioWidth, ratioHeight, ...rest }) => {
  const ratio = (ratioHeight / ratioWidth) * 100 + '%';
  return (
    <Box
      {...rest}
      sx={[
        {
          position: 'relative',
          pb: ratio,
        },
        ...(Array.isArray(rest.sx) ? rest.sx : [rest.sx]),
      ]}
    >
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
        }}
      >
        {children}
      </Box>
    </Box>
  );
};
